export default {
  'PerceptualMappingChart.title': 'Карта восприятия',
  'PerceptualMappingChart.noTopics': 'Выберите 2 темы из списка',
  'PerceptualMappingChart.good': 'Хорошо',
  'PerceptualMappingChart.bad': 'Плохо',
  'PerceptualMappingChart.neutral': 'Нейтрально',
}
